import Toast from './toast.vue'

//  单例模式
let vm

const install = (Vue) => {
  const Component = Vue.extend(Toast)

  /* eslint no-param-reassign: "off" */
  Vue.prototype.$toast = (content, options, autoShow = true) => {
    const data = {
      content
    }

    if (vm) {
      vm.$destroy()
    }

    if (typeof options === 'string') {
      data.type = options
    } else {
      Object.assign(data, options)
    }

    vm = new Component({ data }).$mount()
    if (autoShow) {
      vm.show = true
    }

    vm.$on('destroyed', () => {
      vm = null
    })

    return vm
  }
}

export default install



// WEBPACK FOOTER //
// ./src/_components/public/toast/index.js